import { apiDataSource, shapeEntity } from 'utils/entities';
import { fetchEntities } from 'utils/api/entities.api';

/**
 * Resolve one category for a breadcrumb trail.
 *
 * The data source matters: the same category id sits under a different parent,
 * and carries different cat1..cat5 labels, depending on which source you ask.
 */
export const categoryQueryFn = async ({ queryKey }) => {
    const { id, dataSource } = queryKey[1];
    const entities = await fetchEntities({
        dataSource: apiDataSource(dataSource),
        entityType: 'categories',
        ids: [id],
    });
    const entity = entities?.[id];
    return entity ? shapeEntity(entity) : undefined;
};
